import { createFileRoute } from "@tanstack/react-router";
import { DeploymentDetailPage } from "@charphq/ui/components/layout/pages/DeploymentDetailPage";

export const Route = createFileRoute("/deployments_/$deploymentId")({
  component: DeploymentDetailComponent,
});

function DeploymentDetailComponent() {
  const { deploymentId } = Route.useParams();
  return <DeploymentDetailPage deploymentId={deploymentId} />;
}
